import type { PaymentMethod } from '@pos/types';

export const METHOD_LABEL: Record<PaymentMethod, string> = {
  CASH: 'Наличные',
  CARD: 'Карта',
  CLICK: 'Click',
  PAYME: 'Payme',
  QR: 'QR',
};

const time = new Intl.DateTimeFormat('ru-RU', { hour: '2-digit', minute: '2-digit' });
const dayMonth = new Intl.DateTimeFormat('ru-RU', { day: 'numeric', month: 'long' });
const weekday = new Intl.DateTimeFormat('ru-RU', { weekday: 'long', day: 'numeric', month: 'long' });

function startOfDay(d: Date): number {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
}

/** "14:05", "вчера, 18:40", "12 сентября, 09:10". */
export function when(iso: string, now = new Date()): string {
  const d = new Date(iso);
  const days = Math.round((startOfDay(now) - startOfDay(d)) / 86_400_000);
  if (days === 0) return time.format(d);
  if (days === 1) return `вчера, ${time.format(d)}`;
  return `${dayMonth.format(d)}, ${time.format(d)}`;
}

/** "5 мин назад" for the last minutes, otherwise `when`. */
export function ago(iso: string, now = new Date()): string {
  const min = Math.floor((now.getTime() - new Date(iso).getTime()) / 60_000);
  if (min < 1) return 'только что';
  if (min < 60) return `${min} мин назад`;
  return when(iso, now);
}

/** Section header for a day in a list: "Сегодня", "Вчера", "Пятница, 25 сентября". */
export function dayHeader(iso: string, now = new Date()): string {
  const d = new Date(iso);
  const days = Math.round((startOfDay(now) - startOfDay(d)) / 86_400_000);
  if (days === 0) return 'Сегодня';
  if (days === 1) return 'Вчера';
  const s = weekday.format(d);
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function todayLong(now = new Date()): string {
  const s = weekday.format(now);
  return s.charAt(0).toUpperCase() + s.slice(1);
}
